import { cn } from "@omni/utils/styles";

type LogoutButtonProps = {
    text: string;
    logout: () => void;
};

const LogoutButton = ({ text, logout }: LogoutButtonProps) => (
    <div
        className={cn(
            "tw:text-primary tw:hover:cursor-pointer tw:hover:underline"
        )}
    >
        <button
            type={"button"}
            className={"usp-bar__item"}
            onClick={(e) => {
                e.preventDefault();
                logout();
            }}
        >
            <div className="usp-bar__item-icon ">
                <i className="las la-undo" />
            </div>
            <div className="usp-bar__item-description body-copy-1">{text}</div>
        </button>
    </div>
);

export default LogoutButton;
